export default __webpack_public_path__ + "static/media/pictogramBeaconCamera128.959b5cfe.svg";